import axios from "@/axios.js"



function createFilterSql(mapper, key, item) {
  if (item.operator) {      

    let all_conditions = []
    item.conditions.map((condition) => {
      var cond = mapper(key, condition);
      all_conditions.push(cond + " " + item.operator)
    });

    let final_condtion = all_conditions.join(' ')
    // remove last operator
    final_condtion = final_condtion.substring(0, final_condtion.lastIndexOf(" "));
    return "(" + final_condtion + ")";

  }else{

    return mapper(key, item);

  }  

  

}

function textFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = '" + item.filter + "'";
    case "notEqual":
      let option1 =  key + " != '" + item.filter + "'";
      let option2 =   key + " IS NULL";
      return "(" + option1 + " or " + option2 + ")";
    case "contains":
      return key + " ILIKE '%" + item.filter + "%'";
    case "notContains":
      let option3 =  key + " NOT ILIKE '%" + item.filter + "%'";
      let option4 =   key + " IS NULL";
      return "(" + option3 + " or " + option4 + ")";
    case "startsWith":
      return key + " ILIKE '" + item.filter + "%'";
    case "endsWith":
      return key + " ILIKE '%" + item.filter + "'";
        case "blank":
        let empty_value1 = '[""]'
        return "(" + key + " is NULL or " + key + " = '' or " + key + " = '" + empty_value1 + "')";
    case "notBlank":
      let empty_value = '[""]'
      return "(" + key + " is not NULL and " + key + " != '' and " + key + " != '" + empty_value + "')";
    default:
      console.log("unknown text filter type: " + item.type);
  }
}

function dateFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = '" + item.dateFrom + "'";
    case "notEqual":
      let option1 =  key + " != '" + item.dateFrom + "'";
      let option2 =   key + " IS NULL";
      return "(" + option1 + " or " + option2 + ")";
    case "greaterThan":
      return key + " > '" + item.dateFrom + "'";
    case "greaterThanOrEqual":
      return key + " >= '" + item.dateFrom + "'";
    case "lessThan":
      return key + " < '" + item.dateFrom + "'";
    case "lessThanOrEqual":
      return key + " <= '" + item.dateFrom + "'";
       case "blank":
        return "(" + key + " is NULL)";
    case "notBlank":
        return "(" + key + " is not NULL)";
     case "inRange":
      return (
        "(" +
        key +
        " >= '" +
        item.dateFrom +
        "' and " +
        key +
        " <= '" +
        item.dateTo +
        "')"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}

function numberFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = " + item.filter;
    case "notEqual":
      let option3 =  key + " != '" + item.filter + "'";
      let option4 =  key + " IS NULL";
      return "(" + option3 + " or " + option4 + ")";
    case "greaterThan":
      return key + " > " + item.filter;
    case "greaterThanOrEqual":
      return key + " >= " + item.filter;
    case "lessThan":
      let option5 =  key + " < '" + item.filter + "'";
      let option6 =  key + " IS NULL";
      return "(" + option5 + " or " + option6 + ")";
    case "lessThanOrEqual":
      return key + " <= " + item.filter;
      case "blank":
        return "(" + key + " is NULL)";
    case "notBlank":
        return "(" + key + " is not NULL)";
    case "inRange":
      return (
        "(" +
        key +
        " >= " +
        item.filter +
        " and " +
        key +
        " <= " +
        item.filterTo +
        ")"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}


export default {
  getAllGrades(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_grades');
    console.log(SQL)

    axios.post("/api/grades/grades/get_all_grades", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getAllGradeSteps(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_grade_steps');
    console.log(SQL)

    axios.post("/api/grades/grades/get_all_grade_steps", {
        sql: SQL
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  buildSql(request, method) {
    let selectSql;
    let fromSql;
    if (method == 'get_all_grades') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaign_grade ";
    }
    if (method == 'get_all_grade_steps') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM campaign_grade_steps ";
    }
    const whereSql = this.whereSql(request, method);
    const limitSql = this.limitSql(request);
    const orderBySql = this.orderBySql(request,method);
    const groupBySql = this.groupBySql(request);

    return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;
  },
  groupBySql(request) {
    var rowGroupCols = request.rowGroupCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];

      return " GROUP BY " + rowGroupCol.id;
    }

    return "";
  },
  getRowCount(request, results) {
    if (results === null || results === undefined || results.length === 0) {
      return null;
    }
    const currentLastRow = request.startRow + results.length;
    return currentLastRow <= request.endRow ? currentLastRow : -1;
  },

  cutResultsToPageSize(request, results) {
    const pageSize = request.endRow - request.startRow;
    if (results && results.length > pageSize) {
      return results.splice(0, pageSize);
    } else {
      return results;
    }
  },
  selectSql(request, method) {


    var rowGroupCols = request.rowGroupCols;
    var valueCols = request.valueCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];
      var colsToSelect = [rowGroupCol.id];

      valueCols.forEach(function (valueCol) {
        colsToSelect.push(
          valueCol.aggFunc + "(" + valueCol.id + ") AS " + valueCol.id
        );
      });

      return "SELECT " + colsToSelect.join(", ");
    } else if (method == 'get_all_grades') {
      return `SELECT *`;
  } else if (method == 'get_all_grade_steps') {
    return `SELECT distinct *`;
  } else {
      return "SELECT distinct a.*";
    }

  },
  whereSql(request, method) {
    var whereParts = [];
    var filterModel = request.filterModel;
    if (method == 'get_all_grades') {
      whereParts.push("deleted = False")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    } 
    if (method == 'get_all_grade_steps') {
      whereParts.push("deleted = False")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }else {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }


    if (whereParts.length > 0) {
      return " WHERE " + whereParts.join(" AND ");
    }

    return "";
  },
  isDoingGrouping(rowGroupCols, groupKeys) {
    // we are not doing grouping if at the lowest level
    return rowGroupCols.length > groupKeys.length;
  },
  orderBySql(request,method) {
    var sortModel = request.sortModel;
    if (method == 'get_all_grades') {
      if (sortModel.length === 0) return " ORDER BY created_at DESC";
    }else{
      if (sortModel.length === 0) return "";
    }


    var sorts = sortModel.map(function (s) {
      return s.colId + " " + s.sort.toUpperCase();
    });

    return " ORDER BY " + sorts.join(", ") + " NULLS LAST ";
  },
  limitSql(request) {
    var blockSize = request.endRow - request.startRow;

    return " LIMIT " + (blockSize + 1) + " OFFSET " + request.startRow;
  },
  getLastRowIndex(request, results) {
    if (!results || results.length === 0) {
      return request.startRow;
    }

    var currentLastRow = request.startRow + results.length;

    return currentLastRow <= request.endRow ? currentLastRow : -1;
  }

  // helper methods ...
};
